import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { Button } from '@/components/shared/Button';
import { Icons, IconsTypes } from '@/components/shared/Icons';
import { COMMON_LOCALE_PART } from '@/locale';
import { Colors } from '@/types';

export const EmptyContent: FC = () => {
  const { t } = useTranslation(COMMON_LOCALE_PART);
  const router = useRouter();

  const handleBack = () => router.push('/');

  return (
    <section className="container flex min-h-screen flex-col items-center justify-center ">
      <div className="pb-11 md:pt-28">
        <Icons name={IconsTypes.NOT_FOUND} />
      </div>
      <h2 className="mb-6 text-3xl md:text-4xl">{t('not-found.title')}</h2>
      <p className="text-center text-md">{t('not-found.text')}</p>
      <Button className="mt-11" type="button" variant={Colors.primary} onClick={handleBack}>
        {t('not-found.button')}
      </Button>
    </section>
  );
};
